module.exports = __webpack_public_path__ + "static/headerIcon-5c4ae72ee44606b965a6f93d3720dd52.svg";